export default __webpack_public_path__ + "static/mercedes_benz-d465766cbd232a4bd542b61f3a9d0f2f.png";